import React, { Component } from 'react';
import CustomersStore from '../store/CustomersStore';

const customersDb = new CustomersStore('customersDb');

export const withCustomers = (WrappedComponent) => class WithCustomers extends Component {
    state = {
      customers: [],
    };

    load = () => {
      customersDb.load((customers) => {
        if (!customers) {
          return;
        }

        this.setState({ customers: Object.values(customers) });
      });
    };

    fetch = (credentials, onFetched = () => {}, onError) => {
      const onSuccess = () => {
        this.load();
        onFetched();
      };

      customersDb.fetchFromSalesforceAndSave({
        credentials,
        onSuccess,
        onError,
      });
    };

    render() {
      return (
        <WrappedComponent
          customers={{
            value: this.state.customers,
            fetch: this.fetch,
            load: this.load,
          }}
          {...this.props}
        />
      );
    }
};

export default withCustomers;
